<template>
    <div class="tab-and-ad">
        <!-- 主要内容区域 -->
        <div class="main-content">
            <!-- 左侧：通知公告 -->
            <div class="left-section">
                <div class="notice-header">
                    <div class="notice-title">
                        <img src="@/assets/image/new_slices/Notice.png" class="house-icon">
                        <span class="notice-title-text">通知公告</span>
                    </div>
                    <a href="#" class="more-link">更多</a>
                </div>
                <div class="notice-list">
                    <div class="notice-item">
                        <span class="dot"></span>
                        <span class="notice-text">关于不法分子冒充平台客服违法推销的通知</span>
                    </div>
                    <div class="notice-item">
                        <span class="dot"></span>
                        <span class="notice-text">关于外部网站通过摘取平台项目信息从事违法犯罪行为的处罚措施...</span>
                    </div>
                    <div class="notice-item">
                        <span class="dot"></span>
                        <span class="notice-text">关于不法分子冒充平台客服违法推销的通知！</span>
                    </div>
                    <div class="notice-item">
                        <span class="dot"></span>
                        <span class="notice-text">关于外部网站通过摘取平台项目信息从事违法犯罪行为的处罚措施...</span>
                    </div>
                    <div class="notice-item">
                        <span class="dot"></span>
                        <span class="notice-text">关于不法分子冒充平台客服违法推销的通知！</span>
                    </div>
                    <div class="notice-item">
                        <span class="dot"></span>
                        <span class="notice-text">关于外部网站通过摘取平台项目信息从事违法犯罪行为的处罚措施...</span>
                    </div>
                </div>
            </div>

            <!-- 中间广告 -->
            <div class="center-section" :class="{ 'no-banner': !bannerPath || bannerLoadError }">
                <img v-if="bannerPath && !bannerLoadError" :src="bannerPath" alt="banner" class="center-banner-image"
                    @error="handleBannerError" @load="handleBannerLoad" />
                <div class="center-section-mask"></div>
                <div class="ad-content">
                    <div class="ad-logo">
                           <img :src="adLogoPath" :alt="companyName">
                        
                    </div>
                    <div class="ad-text">
                        <h2 class="ad-title">企业拓客新引擎</h2>
                        <h2 class="ad-subtitle">让每一次投标都精准命中</h2>
                    </div>
                    <div class="ad-buttons">
                        <button class="btn-login" @click="handleLogin">登录</button>
                        <button class="btn-register" @click="handleRegister">注册</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabAndAd',
    data() {
        return {
            currentTab: '首页',
            bannerLoadError: false,
        }
    },
    computed: {
        companyName() {
            return this.$channelMaterial.getCompanyName()
        },
        adLogoPath() {
            return this.$channelMaterial.getAdLogoPath()
        },
        bannerPath() {
            return this.$channelMaterial.getBannerPath()
        },
    },

    watch: {
        bannerPath() {
            this.bannerLoadError = false
        }
    },



    
    methods: {
        // 切换标签页
        switchTab(tab) {
            this.currentTab = tab
        },
        // 处理登录
        handleLogin() {
            window.open('/login', '_blank')
        },
        // 处理注册
        handleRegister() {
            window.open('/register', '_blank')
        },
        handleBannerError() {
            this.bannerLoadError = true
        },
        handleBannerLoad() {
            this.bannerLoadError = false
        },
        // 页面点击统一处理
        buttonClick(text) {
            if (text === '我要投标') {
                window.open('/useLogin?type=' + "bidder", '_blank')
            } else if (text === '我要招标') {
                window.open('/useLogin?type=' + "agent", '_blank')
            } else if (text === '我要评标') {
                window.open('/expertLogin', '_blank')
            }
        }
    }
}
</script>

<style lang="less" scoped>
.tab-and-ad {
    width: 100%;

    // 顶部导航栏
    .nav-tabs {
        display: flex;
        background: white;
        height: 56px;

        .tab-item {
            width: 149px;
            height: 56px;
            text-align: center;
            line-height: 56px;
            font-family: PingFang SC, PingFang SC;
            font-size: 16px;
            font-weight: 500;

            &:hover {
                color: #005EEC;
                background: #005EEC;
                color: white;
            }

            &.active {
                color: white;
                background: #005EEC;
                border-bottom-color: #005EEC;
            }
        }
    }

    // 主要内容区域
    .main-content {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        padding: 0px 0px;
        padding-top: 10px;
        height: 391px;

        // 左侧：通知公告
        .left-section {
            -webkit-box-flex: 0;
            -webkit-flex: 0 0 300px;
            -ms-flex: 0 0 300px;
            flex: 0 0 300px;
            width: 300px;
            height: 100%;
            border-bottom: 1px solid #E7E8E9;
            font-size: 18px;
            line-height: 24px;
            font-family: "Microsoft YaHei", "微软雅黑", "SimSun", "宋体", Arial, sans-serif;
            background-color: white;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
            margin-right: 20px;


            .notice-header {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: justify;
                -webkit-justify-content: space-between;
                -ms-flex-pack: justify;
                justify-content: space-between;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -ms-flex-align: center;
                align-items: center;
                border-bottom: 1px solid #f0f0f0;
                height: 46px;
                padding: 0px 15px;

                .notice-title {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -ms-flex-align: center;
                    align-items: center;
                    font-size: 20px;
                    font-weight: 500;
                    color: black;

                    .house-icon {
                        width: 26px;
                        height: 26px;
                        margin-right: 5px;
                    }

                    .notice-title-text {
                        height: 22px;
                        font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
                        font-weight: 400;
                        font-size: 16px;
                        color: #08090A;
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                }

                .more-link {
                    color: #999;
                    text-decoration: none;
                    font-size: 13px;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

            .notice-list {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -ms-flex: 1;
                flex: 1;
                width: 100%;
                height: 391px;
                background: #FFFFFF;
                padding-left: 15px;
                padding-top: 15px;
                overflow: hidden;

                .notice-item {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -ms-flex-align: center;
                    align-items: center;
                    padding-bottom: 15px;

                    .dot {
                        width: 6px;
                        height: 6px;
                        background: #656668;
                        border-radius: 3px;
                        flex-shrink: 0;
                    }

                    .notice-text {
                        padding-left: 10px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        color: #656668;
                        font-size: 14px;
                        padding-right: 15px;

                        &:hover {
                            color: #1890ff;
                        }
                    }
                }
            }
        }

        // 中间：轮播广告
        .center-section {
            -webkit-box-flex: 1;
            -webkit-flex: 1 1 auto;
            -ms-flex: 1 1 auto;
            flex: 1 1 auto;
            min-width: 0; 
            height: 100%;
            background: linear-gradient(135deg, #1f4f96 0%, #2a6bc5 45%, #68a0e6 100%);
            position: relative;
            border-radius: 4px;
            overflow: hidden;
            visibility: visible;
            opacity: 1;

            &.no-banner {
                background: linear-gradient(135deg, #1f4f96 0%, #2a6bc5 45%, #68a0e6 100%);
            }

            .center-banner-image {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                z-index: 0;
            }

            .center-section-mask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, rgba(8, 29, 61, 0.42) 0%, rgba(8, 29, 61, 0.2) 48%, rgba(8, 29, 61, 0.08) 100%);
                z-index: 1;
            }

            .ad-content {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                padding: 54px 49px;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -webkit-flex-direction: column;
                -ms-flex-direction: column;
                flex-direction: column;
                -webkit-box-pack: start;
                -webkit-justify-content: flex-start;
                -ms-flex-pack: start;
                justify-content: flex-start;
                z-index: 2;
            }

            .ad-logo {
                margin-bottom: 28px;
                width: 100%;
                max-width: 280px;
                height: 44px;
                display: flex;

                img {
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: contain;
                    display: block;
                }
            }

            .ad-text {
                margin-bottom: 24px;
                z-index: 10;

                .ad-title,
                .ad-subtitle {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 600;
                    font-size: 32px;
                    color: #FFFFFF;
                    line-height: 1.4;
                    margin: 0;
                    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                }
            }

            .ad-buttons {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-flex-wrap: wrap;
                -ms-flex-wrap: wrap;
                flex-wrap: wrap;
                gap: 12px;
                z-index: 10;
                position: relative;

                button {
                    outline: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                    border: none;
                    font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
                }

                .btn-login {
                    min-width: 120px;
                    max-width: 175px;
                    width: 175px;
                    height: 49px;
                    background: #005EEC;
                    background-color: #005EEC;
                    border: none;
                    border-radius: 0;
                    font-size: 16px;
                    font-weight: 500;
                    color: #FFFFFF;
                    cursor: pointer;
                    -webkit-transition: background-color 0.3s ease;
                    -moz-transition: background-color 0.3s ease;
                    -o-transition: background-color 0.3s ease;
                    transition: background-color 0.3s ease;
                    display: inline-block;
                    line-height: 49px;
                    text-align: center;
                    vertical-align: middle;
                    margin-right: 0;

                    &:hover {
                        background: #0047B8;
                        background-color: #0047B8;
                    }
                    
                    &:active {
                        background: #003A9B;
                        background-color: #003A9B;
                    }
                }

                .btn-register {
                    min-width: 120px;
                    max-width: 175px;
                    width: 175px;
                    height: 49px;
                    background: white;
                    background-color: white;
                    border: 1px solid #FFFFFF;
                    border-radius: 0;
                    font-size: 16px;
                    font-weight: 500;
                    color: #265C72;
                    cursor: pointer;
                    -webkit-transition: all 0.3s ease;
                    -moz-transition: all 0.3s ease;
                    -o-transition: all 0.3s ease;
                    transition: all 0.3s ease;
                    display: inline-block;
                    line-height: 49px;
                    text-align: center;
                    vertical-align: middle;

                    &:hover {
                        background: #f5f5f5;
                        background-color: #f5f5f5;
                    }
                    
                    &:active {
                        background: #e8e8e8;
                        background-color: #e8e8e8;
                    }
                }
            }
        }

        // 右侧：快速操作
        .right-section {
            flex: 0 0 300px;
            padding: 20px;
            display: flex;
            flex-direction: column;
            background-color: white;
            border: 1px solid #f0f0f0;
            border-radius: 4px;
            height: 100%;

            // 登录和注册按钮
            .action-buttons {
                display: flex;
                flex-direction: column;
                gap: 12px;
                margin-bottom: 20px;

                .login-btn {
                    width: 100%;
                    height: 40px;
                    background: #005EEC;
                    color: white;
                    border: none;
                    border-radius: 6px;
                    font-size: 16px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: background-color 0.3s ease;

                    &:hover {
                        background: #0047B8;
                    }

                    &:active {
                        background: #003A9B;
                    }
                }

                .register-btn {
                    width: 100%;
                    height: 40px;
                    background: #FF6B35;
                    color: white;
                    border: none;
                    border-radius: 6px;
                    font-size: 16px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: background-color 0.3s ease;

                    &:hover {
                        background: #E55A2B;
                    }

                    &:active {
                        background: #CC4A21;
                    }
                }
            }

            // 相关下载
            .download-section {
                flex: 1;
                display: flex;
                flex-direction: column;

                .download-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 12px;

                    .download-title {
                        font-size: 16px;
                        // font-weight: 600;
                        color: #333;
                    }

                    .more-link {
                        color: #999;
                        text-decoration: none;
                        font-size: 12px;

                        &:hover {
                            color: #005EEC;
                            text-decoration: underline;
                        }
                    }
                }

                .download-list {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;

                    .download-item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 8px 0;
                        cursor: pointer;
                        transition: color 0.3s ease;

                        &:hover {
                            .download-text {
                                color: #005EEC;
                            }
                        }

                        .download-text {
                            font-size: 14.5px;
                            color: #333;
                            line-height: 1.4;
                            flex: 1;
                            text-align: start;
                        }

                        .download-icon {
                            color: #999;
                            font-size: 16px;
                            // font-weight: bold;
                            margin-left: 8px;
                        }
                    }
                }
            }
        }
    }
}
</style>
